// Validación de formularios reutilizable (client). Minimal y consistente entre
// las páginas de auth (Login/Forgot/Register) y los formularios de marca.

// Formato de email pragmático (no RFC completo): algo@algo.tld, sin espacios.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
